import { Skeleton } from '@/components/ui/skeleton';

const FILTER_SKELETON_MAX_ROWS = 8;

const FILTER_SKELETON_KEYS = Array.from(
  { length: FILTER_SKELETON_MAX_ROWS },
  (_, index) => `filter-skel-${index + 1}`,
);

interface FilterFacetSkeletonProps {
  variant?: 'checkbox' | 'pills';
  rowsCount?: number;
}

export const FilterFacetSkeleton = ({
  variant = 'checkbox',
  rowsCount = 6,
}: FilterFacetSkeletonProps) => {
  const visibleKeys = FILTER_SKELETON_KEYS.slice(0, rowsCount);

  if (variant === 'pills') {
    return (
      <div className="flex flex-wrap gap-2" aria-hidden="true">
        {visibleKeys.map((rowKey) => (
          <Skeleton key={rowKey} className="h-6 w-16 rounded-lg" />
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2" aria-hidden="true">
      {visibleKeys.map((rowKey) => (
        <div key={rowKey} className="flex items-center gap-2">
          <Skeleton className="size-4 shrink-0 rounded" />
          <Skeleton className="h-3 flex-1" />
          <Skeleton className="h-4 w-8 shrink-0 rounded" />
        </div>
      ))}
    </div>
  );
};
